/**
 * EmploymentTypeOption is a constant object that provides a set of predefined employment type options with corresponding labels and values.
 *
 * The available options include:
 *   - FullTime: Represents full-time employment with a key value of 'full-time'.
 *   - PartTime: Represents part-time employment with a key value of 'part-time'.
 *   - Contract: Represents contractual employment with a key value of 'contract'.
 *   - Casual: Represents casual employment with a key value of 'casual'.
 *   - Temporary: Represents temporary or short-term employment with a key value of 'temporary'.
 *   - Voluntary: Represents voluntary work with a key value of 'voluntary'.
 *   - Other: Represents other types of employment with a key value of 'other'.
 *
 * @typedef {{label: string, value: string}} EmploymentType
 * @type {Readonly<{string: EmploymentType}>}
 * @enum
 */
export const EmploymentTypeOption = Object.freeze({
    FullTime: { label: 'Full-time', value: 'full-time' },
    PartTime: { label: 'Part-time', value: 'part-time' },
    Contract: { label: 'Contract', value: 'contract' },
    Casual: { label: 'Casual', value: 'casual' },
    Temporary: { label: 'Temporary', value: 'temporary' },
    Voluntary: { label: 'Voluntary', value: 'voluntary' },
    Other: { label: 'Other', value: 'other' }
});
